import { render, staticRenderFns } from "./ProcessNvrAlarm.vue?vue&type=template&id=21404f79&scoped=true"
import script from "./ProcessNvrAlarm.vue?vue&type=script&lang=js"
export * from "./ProcessNvrAlarm.vue?vue&type=script&lang=js"
import style0 from "./ProcessNvrAlarm.vue?vue&type=style&index=0&id=21404f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21404f79",
  null
  
)

export default component.exports